module.exports = __webpack_public_path__ + "static/img/loginBg.29fc93eb.jpg";